import React from 'react';
import { useStyles } from './Icons.styles'
import { iconProps } from './Icon.types';

export const SettingsIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={color}>
      <g id="setting">
        <path
          id="setting-2"
          d="M8.75,22.15a2.67,2.67,0,0,1-1.3-.35l-1.63-.95a2.57,2.57,0,0,1-1.21-1.58,2.61,2.61,0,0,1,.26-2l.44-.75a8.49,8.49,0,0,1-.58-1h-.9a2.6,2.6,0,0,1-2.59-2.61V11A2.54,2.54,0,0,1,2,9.21a2.56,2.56,0,0,1,1.83-.75h.88a7.83,7.83,0,0,1,.59-1l-.44-.79a2.58,2.58,0,0,1,1-3.54L7.5,2.19a2.6,2.6,0,0,1,3.54,1l.43.75a9.37,9.37,0,0,1,1.06,0L13,3.15a2.6,2.6,0,0,1,1.58-1.21,2.56,2.56,0,0,1,2,.26l1.63.94a2.6,2.6,0,0,1,.95,3.55l-.43.76a7.66,7.66,0,0,1,.6,1h.9a2.61,2.61,0,0,1,2.58,2.62V13a2.61,2.61,0,0,1-2.6,2.58h-.89a8.87,8.87,0,0,1-.55.94l.45.79a2.6,2.6,0,0,1-1,3.54l-1.64.94a2.59,2.59,0,0,1-3.54-1l-.44-.75a7,7,0,0,1-1.12,0l-.46.78A2.6,2.6,0,0,1,8.75,22.15ZM3.85,10a1.13,1.13,0,0,0-.78.31,1.1,1.1,0,0,0-.32.78v1.88A1.1,1.1,0,0,0,3.83,14H5.21a.73.73,0,0,1,.69.46A7,7,0,0,0,6.8,16a.78.78,0,0,1,.06.84l-.69,1.17a1.17,1.17,0,0,0-.11.84,1.09,1.09,0,0,0,.51.66l1.63.95a1.07,1.07,0,0,0,.84.11,1.14,1.14,0,0,0,.67-.51l.69-1.2a.77.77,0,0,1,.75-.37,7.23,7.23,0,0,0,1.74,0,.73.73,0,0,1,.75.36l.68,1.18a1.1,1.1,0,0,0,1.5.41l1.63-.94a1.07,1.07,0,0,0,.52-.66,1.17,1.17,0,0,0-.11-.84l-.69-1.2a.76.76,0,0,1,0-.83,6.75,6.75,0,0,0,.87-1.48.7.7,0,0,1,.69-.47l1.36,0A1.12,1.12,0,0,0,21.25,13V11.1a1.1,1.1,0,0,0-.32-.78,1.07,1.07,0,0,0-.77-.33H18.79a.76.76,0,0,1-.69-.47A6.57,6.57,0,0,0,17.19,8a.76.76,0,0,1-.05-.84l.68-1.18a1.1,1.1,0,0,0-.41-1.5L15.78,3.5A1.05,1.05,0,0,0,15,3.39a1.12,1.12,0,0,0-.67.51l-.69,1.2a.75.75,0,0,1-.75.37,6.83,6.83,0,0,0-1.69,0,.74.74,0,0,1-.74-.37L9.74,3.91a1.11,1.11,0,0,0-1.5-.41L6.6,4.42a1.11,1.11,0,0,0-.42,1.5l.68,1.21A.74.74,0,0,1,6.8,8,7,7,0,0,0,5.9,9.5a.74.74,0,0,1-.69.46H3.85ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Zm0-6.5a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,12,9.5Z"
        />
      </g>
    </svg>
  );
};

export const BellIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={color}>
      <g id="notification">
        <path d="M20.66,14.2A7.25,7.25,0,0,1,19.45,10V9.85a6.34,6.34,0,0,0-5.72-6.3V2.38a.75.75,0,1,0-1.5,0V3.59A6.44,6.44,0,0,0,10.6,4,6.18,6.18,0,0,0,6.8,9.84a7.31,7.31,0,0,1-1.43,4.4l-.67.92A2.86,2.86,0,0,0,7,19.73h3.28v.33a2.7,2.7,0,0,0,5.35,0v-.33H19a2.91,2.91,0,0,0,2.39-4.51Zm-6.5,5.69a1.21,1.21,0,0,1-2.37,0v-.16h2.37ZM19,18.23H7A1.37,1.37,0,0,1,5.9,16.05l.68-.92A8.87,8.87,0,0,0,8.3,9.77a4.66,4.66,0,0,1,2.85-4.36,5.35,5.35,0,0,1,2-.38A4.81,4.81,0,0,1,18,9.84V10a8.84,8.84,0,0,0,1.46,5l.68,1a1.41,1.41,0,0,1,.23.81A1.37,1.37,0,0,1,19,18.23Z" />
      </g>
    </svg>
  );
};

export const ProfileIcon: React.FC<iconProps> = ({
  color = '#aaa',
  width = '15',
  height = '15'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={color}>
      <g id="users">
        <path
          id="user"
          d="M12,12.67A5.71,5.71,0,1,1,17.71,7,5.71,5.71,0,0,1,12,12.67Zm0-9.92A4.21,4.21,0,1,0,16.21,7,4.22,4.22,0,0,0,12,2.75Zm7.7,20H4.3a2,2,0,0,1-1.54-.7,1.74,1.74,0,0,1-.4-1.41c.7-4.15,4.85-7.28,9.64-7.28s8.94,3.13,9.64,7.28a1.74,1.74,0,0,1-.4,1.41A2,2,0,0,1,19.7,22.75ZM12,14.86c-4.07,0-7.58,2.59-8.16,6a.24.24,0,0,0,.06.19.51.51,0,0,0,.4.17H19.7a.51.51,0,0,0,.4-.17.24.24,0,0,0,.06-.19C19.58,17.45,16.07,14.86,12,14.86Z"
        />
      </g>
    </svg>
  );
};

export const SearchIcon: React.FC<iconProps> = ({
  color = '#aaa',
  width = '24',
  height = '24'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M14.2929 16.7071C13.9024 16.3166 13.9024 15.6834 14.2929 15.2929C14.6834 14.9024 15.3166 14.9024 15.7071 15.2929L19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L14.2929 16.7071Z" />
      <path d="M11 16C13.7614 16 16 13.7614 16 11C16 8.23858 13.7614 6 11 6C8.23858 6 6 8.23858 6 11C6 13.7614 8.23858 16 11 16ZM11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 14.866 14.866 18 11 18Z" />
    </svg>
  );
};

export const NotFoundEmoji: React.FC<iconProps> = ({
  color = '#000000',
  width = '32',
  height = '32'
}) => {
  const { classes } = useStyles();
  return (
    <svg
      className={classes.notFoundEmojiIcon}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM80,108a12,12,0,1,1,12,12A12,12,0,0,1,80,108Zm96,0a12,12,0,1,1-12-12A12,12,0,0,1,176,108Zm-1.08,64a8,8,0,1,1-13.84,8c-7.47-12.91-19.21-20-33.08-20s-25.61,7.1-33.08,20a8,8,0,1,1-13.84-8c10.29-17.79,27.39-28,46.92-28S164.63,154.2,174.92,172Z"></path>
    </svg>
  );
};

export const KeyIcon: React.FC<iconProps> = ({
  color = '#524c4c',
  width = '32',
  height = '32'
}) => {
  const { classes } = useStyles();
  return (
    <svg
      className={classes.keyIcon}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"></path>
    </svg>
  );
};

export const FilterIcon: React.FC<iconProps> = ({
  color = '#000000',
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"></path>
    </svg>
  );
};

export const PlusIcon: React.FC<iconProps> = ({
  color = '#fff',
  width = '14px',
  height = '14px'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={color} // Apply the passed color or default to white
    >
      <g id="arrows">
        <path
          id="plus"
          d="M18,11h0l-5,0V6a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V11h-5a1,1,0,0,0,0,2h5v5a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V13l5,0a1,1,0,0,0,0-2Z"
        />
      </g>
    </svg>
  );
};

export const FileIcon: React.FC<iconProps> = ({ color = '#000', width = '20', height = '20' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.675 8.05848C14.6373 8.19138 14.5578 8.30858 14.4482 8.39266C14.3386 8.47674 14.2048 8.5232 14.0666 8.52514H13.9083L9.99165 7.52514C9.83924 7.47044 9.71316 7.36013 9.63868 7.21635C9.5642 7.07257 9.54683 6.90595 9.59006 6.7499C9.63329 6.59385 9.73392 6.45992 9.87177 6.37496C10.0096 6.29 10.1745 6.2603 10.3333 6.29181L14.25 7.30014C14.4054 7.34668 14.5366 7.45181 14.6159 7.59332C14.6952 7.73483 14.7164 7.90164 14.675 8.05848Z"
        fill={color}
      />
      <path
        d="M12.25 10.9C12.2112 11.0322 12.1313 11.1487 12.022 11.2326C11.9126 11.3165 11.7794 11.3634 11.6417 11.3667H11.4833L9.16667 10.7584C9.08775 10.7389 9.01347 10.704 8.94808 10.6557C8.8827 10.6074 8.82751 10.5466 8.78569 10.4769C8.74387 10.4072 8.71625 10.33 8.7044 10.2495C8.69255 10.1691 8.69672 10.0872 8.71667 10.0084C8.7579 9.84833 8.86083 9.71115 9.00295 9.62682C9.14506 9.54249 9.31478 9.51787 9.475 9.55835L11.8 10.1667C11.9547 10.208 12.0875 10.3071 12.1713 10.4436C12.255 10.58 12.2832 10.7434 12.25 10.9Z"
        fill={color}
      />
      <path
        d="M17.9916 4.05837C17.6906 3.50956 17.2837 3.0259 16.7945 2.63539C16.3053 2.24489 15.7435 1.95529 15.1416 1.78337L12.2666 0.950038C11.3201 0.669182 10.3092 0.693525 9.37731 1.01961C8.44541 1.3457 7.63987 1.95698 7.07497 2.7667C6.943 2.78733 6.81225 2.81515 6.68331 2.85004L3.81664 3.68337C2.60675 4.04772 1.59059 4.87678 0.990794 5.98891C0.390993 7.10104 0.256451 8.40557 0.616641 9.6167L2.16664 14.8334C2.34523 15.4338 2.64043 15.9932 3.03536 16.4795C3.43029 16.9658 3.91721 17.3695 4.46827 17.6674C5.01932 17.9654 5.62371 18.1518 6.24687 18.2161C6.87002 18.2803 7.49973 18.221 8.09997 18.0417L10.9666 17.2084C11.5717 17.0432 12.1381 16.7599 12.6333 16.375C13.6167 16.3162 14.5578 15.9547 15.3276 15.34C16.0974 14.7254 16.6583 13.8876 16.9333 12.9417L18.4333 7.73337C18.6123 7.12281 18.6654 6.48227 18.5895 5.85056C18.5136 5.21886 18.3102 4.60914 17.9916 4.05837ZM7.74164 16.8417C6.85097 17.1092 5.8906 17.013 5.07069 16.5741C4.25077 16.1353 3.63807 15.3895 3.36664 14.5L1.81664 9.28337C1.68339 8.84127 1.63872 8.37721 1.6852 7.91781C1.73168 7.45841 1.86839 7.0127 2.08749 6.60624C2.30659 6.19979 2.60377 5.84058 2.96198 5.54922C3.3202 5.25786 3.73241 5.04008 4.17497 4.90837L6.34997 4.25837L4.85831 9.4167C4.68115 10.0186 4.62478 10.6495 4.69242 11.2733C4.76006 11.897 4.95039 12.5012 5.25245 13.0511C5.55451 13.601 5.96234 14.0858 6.45246 14.4775C6.94258 14.8691 7.50533 15.16 8.10831 15.3334L10.5166 16.0334L7.74164 16.8417ZM17.1916 7.3417L15.6833 12.55C15.5593 12.9934 15.3479 13.4075 15.0618 13.7681C14.7756 14.1287 14.4202 14.4286 14.0166 14.65C13.1998 15.1 12.2379 15.2078 11.3416 14.95L8.46664 14.1167C8.02277 13.9883 7.60856 13.7737 7.24769 13.4851C6.88681 13.1965 6.58634 12.8397 6.36345 12.4349C6.14057 12.0301 5.99963 11.5854 5.9487 11.1262C5.89777 10.6669 5.93785 10.2021 6.06664 9.75837L7.56664 4.55004C7.78445 3.83317 8.22501 3.20435 8.82439 2.75482C9.42377 2.30528 10.1508 2.05842 10.9 2.05004C11.2328 2.05093 11.5638 2.09862 11.8833 2.1917L14.7583 3.02504C15.2022 3.15345 15.6164 3.36808 15.9773 3.65665C16.3381 3.94523 16.6386 4.30209 16.8615 4.70685C17.0844 5.1116 17.2253 5.55632 17.2762 6.01557C17.3272 6.47483 17.2871 6.93961 17.1583 7.38337L17.1916 7.3417Z"
        fill={color}
      />
    </svg>
  );
};

export const MessageIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10 19.1666C9.68631 19.1648 9.37755 19.0882 9.09931 18.9433C8.82107 18.7984 8.58136 18.5893 8.40002 18.3333L7.50002 17.0083C7.45223 16.9397 7.38872 16.8834 7.3148 16.8443C7.24087 16.8051 7.15866 16.7842 7.07502 16.7833H5.71669C4.4768 16.7833 3.2877 16.2908 2.41096 15.414C1.53423 14.5373 1.04169 13.3482 1.04169 12.1083V5.9333C1.04169 4.69341 1.53423 3.50431 2.41096 2.62758C3.2877 1.75084 4.4768 1.2583 5.71669 1.2583H14.2834C14.8973 1.2583 15.5052 1.37922 16.0724 1.61416C16.6396 1.8491 17.155 2.19346 17.5891 2.62758C18.0232 3.06169 18.3675 3.57706 18.6025 4.14426C18.8374 4.71145 18.9584 5.31937 18.9584 5.9333V12.1083C18.9584 12.7222 18.8374 13.3301 18.6025 13.8973C18.3675 14.4645 18.0232 14.9799 17.5891 15.414C17.155 15.8481 16.6396 16.1925 16.0724 16.4274C15.5052 16.6624 14.8973 16.7833 14.2834 16.7833H12.9584C12.8747 16.7842 12.7925 16.8051 12.7186 16.8443C12.6446 16.8834 12.5811 16.9397 12.5334 17.0083L11.6 18.3333C11.4187 18.5893 11.179 18.7984 10.9007 18.9433C10.6225 19.0882 10.3137 19.1648 10 19.1666ZM5.71669 2.49997C5.26621 2.49997 4.82015 2.58883 4.40407 2.76148C3.98798 2.93412 3.61004 3.18715 3.29189 3.50607C2.97375 3.825 2.72164 4.20355 2.55 4.62005C2.37837 5.03655 2.29059 5.48282 2.29169 5.9333V12.1083C2.29169 13.0167 2.65253 13.8878 3.29485 14.5301C3.93716 15.1725 4.80832 15.5333 5.71669 15.5333H7.04169C7.32649 15.5341 7.60691 15.6034 7.85928 15.7354C8.11165 15.8674 8.32856 16.0582 8.49169 16.2916L9.41669 17.6083C9.48511 17.6981 9.57336 17.7709 9.67454 17.821C9.77572 17.8712 9.88711 17.8972 10 17.8972C10.1129 17.8972 10.2243 17.8712 10.3255 17.821C10.4267 17.7709 10.5149 17.6981 10.5834 17.6083L11.5084 16.2916C11.6715 16.0582 11.8884 15.8674 12.1408 15.7354C12.3931 15.6034 12.6736 15.5341 12.9584 15.5333H14.2834C15.1917 15.5333 16.0629 15.1725 16.7052 14.5301C17.3475 13.8878 17.7084 13.0167 17.7084 12.1083V5.9333C17.7094 5.48282 17.6217 5.03655 17.45 4.62005C17.2784 4.20355 17.0263 3.825 16.7081 3.50607C16.39 3.18715 16.0121 2.93412 15.596 2.76148C15.1799 2.58883 14.7338 2.49997 14.2834 2.49997H5.71669ZM14.5917 7.39997C14.5895 7.23488 14.523 7.07716 14.4062 6.96041C14.2895 6.84367 14.1318 6.77713 13.9667 6.77497H6.03335C5.86759 6.77497 5.70862 6.84082 5.59141 6.95803C5.4742 7.07524 5.40835 7.23421 5.40835 7.39997C5.40835 7.56573 5.4742 7.7247 5.59141 7.84191C5.70862 7.95912 5.86759 8.02497 6.03335 8.02497H13.9667C14.1318 8.02281 14.2895 7.95627 14.4062 7.83952C14.523 7.72278 14.5895 7.56506 14.5917 7.39997ZM13.2667 11.5666C13.2667 11.4009 13.2008 11.2419 13.0836 11.1247C12.9664 11.0075 12.8074 10.9416 12.6417 10.9416H7.35835C7.19259 10.9416 7.03362 11.0075 6.91641 11.1247C6.7992 11.2419 6.73335 11.4009 6.73335 11.5666C6.73335 11.7324 6.7992 11.8914 6.91641 12.0086C7.03362 12.1258 7.19259 12.1916 7.35835 12.1916H12.6417C12.8074 12.1916 12.9664 12.1258 13.0836 12.0086C13.2008 11.8914 13.2667 11.7324 13.2667 11.5666Z" />
    </svg>
  );
};

export const FilesFolderIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12.425 17.9583H5.57499C4.11915 17.9694 2.71829 17.4028 1.6795 16.3828C0.640703 15.3627 0.048724 13.9724 0.0333252 12.5166V6.13327C0.0376861 5.41029 0.184548 4.69526 0.46551 4.02909C0.746471 3.36293 1.15602 2.75869 1.67072 2.25095C2.18543 1.74321 2.79519 1.34193 3.46512 1.07008C4.13506 0.798217 4.85202 0.661111 5.57499 0.666602H8.52499C8.60707 0.666602 8.68834 0.682768 8.76417 0.714177C8.84 0.745586 8.9089 0.791623 8.96693 0.84966C9.02497 0.907696 9.07101 0.976596 9.10242 1.05242C9.13382 1.12825 9.14999 1.20953 9.14999 1.2916C9.14999 1.37368 9.13382 1.45495 9.10242 1.53078C9.07101 1.60661 9.02497 1.67551 8.96693 1.73354C8.9089 1.79158 8.84 1.83762 8.76417 1.86903C8.68834 1.90044 8.60707 1.9166 8.52499 1.9166H5.57499C4.45858 1.90985 3.38453 2.34351 2.58579 3.12353C1.78705 3.90355 1.32804 4.96702 1.30832 6.08327V12.4666C1.32804 13.5829 1.78705 14.6463 2.58579 15.4263C3.38453 16.2064 4.45858 16.64 5.57499 16.6333H12.425C13.5414 16.64 14.6155 16.2064 15.4142 15.4263C16.2129 14.6463 16.6719 13.5829 16.6917 12.4666V8.28327C16.7096 8.12675 16.7845 7.9823 16.902 7.87743C17.0196 7.77256 17.1716 7.71461 17.3292 7.71461C17.4867 7.71461 17.6387 7.77256 17.7563 7.87743C17.8739 7.9823 17.9487 8.12675 17.9667 8.28327V12.5166C17.9513 13.9724 17.3593 15.3627 16.3205 16.3828C15.2817 17.4028 13.8808 17.9694 12.425 17.9583ZM13.7333 1.2916C13.6121 1.28928 13.4921 1.31607 13.3833 1.36972C13.2746 1.42337 13.1803 1.50231 13.1083 1.59993L12.6167 2.23327C12.7823 2.90676 13.1846 3.49827 13.75 3.89994C14.2732 4.29608 14.9104 4.5124 15.5667 4.5166H15.6667L16.1583 3.88327C16.2197 3.80349 16.2645 3.7123 16.2903 3.61501C16.316 3.51773 16.3222 3.41628 16.3083 3.3166C16.2962 3.21689 16.2632 3.12085 16.2115 3.03471C16.1598 2.94857 16.0906 2.87426 16.0083 2.8166L14.2 1.44994C14.0664 1.34668 13.9022 1.29096 13.7333 1.2916ZM13.7333 0.0416015C14.1776 0.0415955 14.6101 0.184784 14.9667 0.449935L16.7917 1.79993C17.0063 1.95697 17.1873 2.15538 17.324 2.38349C17.4607 2.61159 17.5503 2.86476 17.5876 3.12806C17.6248 3.39136 17.609 3.65946 17.541 3.91655C17.473 4.17363 17.3542 4.4145 17.1917 4.62494L16.6417 5.3416C16.5608 5.44846 16.4595 5.53814 16.3436 5.60538C16.2277 5.67263 16.0995 5.71611 15.9667 5.73327H15.5667C14.6362 5.7376 13.7285 5.44574 12.975 4.89994C12.1135 4.27982 11.5182 3.35708 11.3083 2.3166C11.2885 2.18456 11.2961 2.04985 11.3305 1.92084C11.3649 1.79183 11.4254 1.67126 11.5083 1.5666L12.0583 0.849935C12.2524 0.591193 12.504 0.381186 12.7933 0.236545C13.0826 0.0919038 13.4016 0.0166016 13.725 0.0166016L13.7333 0.0416015ZM9.93332 5.70827L8.06666 8.1666C7.98486 8.26861 7.9381 8.39427 7.93332 8.52494V11.1583C7.92931 11.1907 7.93329 11.2235 7.94491 11.2541C7.95653 11.2846 7.97544 11.3118 7.99999 11.3333C8.05093 11.3845 8.11948 11.4143 8.19166 11.4166H8.26666L10.8167 10.6666C10.9424 10.6252 11.0528 10.5467 11.1333 10.4416L13 8.02494C12.4069 7.78613 11.8468 7.47248 11.3333 7.0916C10.8174 6.70743 10.355 6.25624 9.95832 5.74994M9.99999 3.94994C10.0946 3.94771 10.1879 3.97237 10.269 4.02105C10.3501 4.06973 10.4158 4.14043 10.4583 4.22494C10.8765 4.95738 11.4444 5.59344 12.125 6.0916C12.8022 6.59741 13.5813 6.95 14.4083 7.12494C14.4979 7.13875 14.5821 7.17626 14.6523 7.23358C14.7225 7.2909 14.7761 7.36594 14.8076 7.45093C14.839 7.53592 14.8472 7.62777 14.8312 7.71697C14.8152 7.80618 14.7757 7.88948 14.7167 7.95827L12.2167 11.2249C11.9719 11.5446 11.6296 11.7758 11.2417 11.8833L8.66666 12.6333C8.52605 12.6757 8.38018 12.6981 8.23332 12.6999C8.03174 12.7033 7.83153 12.6662 7.64453 12.5909C7.45753 12.5155 7.28753 12.4034 7.14459 12.2613C7.00164 12.1191 6.88864 11.9497 6.81228 11.7631C6.73592 11.5765 6.69774 11.3765 6.69999 11.1749V8.5416C6.70656 8.14194 6.84416 7.75548 7.09166 7.4416L9.59166 4.17494C9.64206 4.11293 9.70555 4.06284 9.77759 4.02826C9.84963 3.99369 9.92842 3.97548 10.0083 3.97494L9.99999 3.94994Z" />
    </svg>
  );
};

export const Support: React.FC<iconProps> = ({
  color = '#010929',
  width = '18',
  height = '18'
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00002 17.9584C7.22823 17.9584 5.49623 17.433 4.02304 16.4487C2.54985 15.4643 1.40164 14.0652 0.723604 12.4283C0.0455685 10.7914 -0.131836 8.99015 0.213823 7.2524C0.559482 5.51465 1.41268 3.91843 2.66553 2.66559C3.91837 1.41274 5.51459 0.559543 7.25234 0.213884C8.99009 -0.131775 10.7913 0.0456296 12.4282 0.723665C14.0652 1.4017 15.4643 2.54991 16.4486 4.0231C17.433 5.49629 17.9584 7.22829 17.9584 9.00008C17.9562 11.3753 17.0116 13.6526 15.3321 15.3321C13.6526 17.0117 11.3752 17.9562 9.00002 17.9584ZM9.00002 1.29175C7.47546 1.29175 5.98513 1.74384 4.7175 2.59084C3.44987 3.43784 2.46188 4.64172 1.87845 6.05023C1.29503 7.45875 1.14238 9.00864 1.4398 10.5039C1.73723 11.9992 2.47138 13.3727 3.54941 14.4507C4.62744 15.5287 6.00093 16.2629 7.4962 16.5603C8.99147 16.8577 10.5414 16.7051 11.9499 16.1217C13.3584 15.5382 14.5623 14.5502 15.4093 13.2826C16.2563 12.015 16.7084 10.5246 16.7084 9.00008C16.7062 6.95638 15.8933 4.99702 14.4482 3.55191C13.0031 2.10679 11.0437 1.29396 9.00002 1.29175Z"
        fill={color}
      />
      <path
        d="M9.00002 7.8335C9.22103 7.8335 9.433 7.92129 9.58928 8.07757C9.74556 8.23385 9.83335 8.44582 9.83335 8.66683V12.5502C9.83335 12.7712 9.74556 12.9831 9.58928 13.1394C9.433 13.2957 9.22103 13.3835 9.00002 13.3835C8.77901 13.3835 8.56705 13.2957 8.41076 13.1394C8.25448 12.9831 8.16669 12.7712 8.16669 12.5502V8.66683C8.16669 8.44582 8.25448 8.23385 8.41076 8.07757C8.56705 7.92129 8.77901 7.8335 9.00002 7.8335Z"
        fill={color}
      />
      <path
        d="M9.00004 6.70003C9.57534 6.70003 10.0417 6.23366 10.0417 5.65837C10.0417 5.08307 9.57534 4.6167 9.00004 4.6167C8.42474 4.6167 7.95837 5.08307 7.95837 5.65837C7.95837 6.23366 8.42474 6.70003 9.00004 6.70003Z"
        fill={color}
      />
    </svg>
  );
};

export const AddIcon: React.FC<iconProps> = ({
  color = '#3377FF',
  width = '15',
  height = '13'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 13"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M7.11815 0C5.71031 0 4.33409 0.381218 3.16352 1.09545C1.99295 1.80968 1.0806 2.82484 0.54184 4.01256C0.00308419 5.20028 -0.137879 6.50721 0.136776 7.76809C0.411432 9.02896 1.08937 10.1872 2.08486 11.0962C3.08035 12.0052 4.34868 12.6243 5.72947 12.8751C7.11025 13.1259 8.54147 12.9972 9.84214 12.5052C11.1428 12.0132 12.2545 11.1801 13.0367 10.1112C13.8188 9.04229 14.2363 7.78558 14.2363 6.5C14.2343 4.77666 13.4837 3.12445 12.1492 1.90586C10.8147 0.687282 9.00537 0.00186392 7.11815 0ZM7.11815 11.9167C5.94495 11.9167 4.7981 11.599 3.82262 11.0038C2.84715 10.4086 2.08685 9.56263 1.63789 8.57287C1.18893 7.5831 1.07146 6.49399 1.30034 5.44326C1.52922 4.39253 2.09417 3.42737 2.92374 2.66984C3.75332 1.9123 4.81026 1.39642 5.96091 1.18741C7.11157 0.97841 8.30425 1.08568 9.38814 1.49565C10.472 1.90563 11.3985 2.59989 12.0502 3.49066C12.702 4.38143 13.0499 5.42868 13.0499 6.5C13.0482 7.9361 12.4227 9.31294 11.3106 10.3284C10.1986 11.3439 8.69083 11.9151 7.11815 11.9167ZM10.084 6.5C10.084 6.64366 10.0215 6.78143 9.9103 6.88301C9.79906 6.9846 9.64818 7.04167 9.49086 7.04167H7.71133V8.66667C7.71133 8.81032 7.64883 8.9481 7.53759 9.04968C7.42635 9.15126 7.27547 9.20833 7.11815 9.20833C6.96083 9.20833 6.80995 9.15126 6.69871 9.04968C6.58746 8.9481 6.52497 8.81032 6.52497 8.66667V7.04167H4.74543C4.58811 7.04167 4.43723 6.9846 4.32599 6.88301C4.21475 6.78143 4.15225 6.64366 4.15225 6.5C4.15225 6.35634 4.21475 6.21856 4.32599 6.11698C4.43723 6.0154 4.58811 5.95833 4.74543 5.95833H6.52497V4.33333C6.52497 4.18967 6.58746 4.0519 6.69871 3.95032C6.80995 3.84873 6.96083 3.79167 7.11815 3.79167C7.27547 3.79167 7.42635 3.84873 7.53759 3.95032C7.64883 4.0519 7.71133 4.18967 7.71133 4.33333V5.95833H9.49086C9.64818 5.95833 9.79906 6.0154 9.9103 6.11698C10.0215 6.21856 10.084 6.35634 10.084 6.5Z" />
    </svg>
  );
};

export const CrossIcon: React.FC<iconProps> = ({
  color = '#00000033',
  width = '12',
  height = '12'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 8"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}>
      <g clipPath="url(#clip0_80_10465)">
        <path
          d="M4.47134 3.99793L7.9024 0.566865C8.0303 0.434457 8.02664 0.223422 7.89423 0.095529C7.76506 -0.0292388 7.56024 -0.0292388 7.43107 0.095529L3.99999 3.52659L0.568932 0.095529C0.436508 -0.0323639 0.225488 -0.0286919 0.0975955 0.103717C-0.0271723 0.232891 -0.0271723 0.437691 0.0975955 0.566865L3.52866 3.99793L0.0975955 7.42899C-0.0325318 7.55916 -0.0325318 7.77016 0.0975955 7.90032C0.22777 8.03045 0.438773 8.03045 0.568932 7.90032L3.99999 4.46926L7.43105 7.90032C7.56123 8.03045 7.77223 8.03045 7.90239 7.90032C8.03251 7.77015 8.03251 7.55914 7.90239 7.42899L4.47134 3.99793Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_80_10465">
          <rect width="8" height="8" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CheckIcon: React.FC<iconProps> = ({
  color = '#000000',
  width = '32',
  height = '32'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
    </svg>
  );
};

export const AddImageIcon: React.FC<iconProps> = ({
  color = '#000000',
  width = '15',
  height = '13'
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 13" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_59_83)">
        <path
          d="M11.494 0H3.18953C2.40321 0.00086009 1.64937 0.286478 1.09336 0.794202C0.537354 1.30193 0.224575 1.9903 0.223633 2.70833L0.223633 10.2917C0.224575 11.0097 0.537354 11.6981 1.09336 12.2058C1.64937 12.7135 2.40321 12.9991 3.18953 13H11.494C12.2803 12.9991 13.0342 12.7135 13.5902 12.2058C14.1462 11.6981 14.459 11.0097 14.4599 10.2917V2.70833C14.459 1.9903 14.1462 1.30193 13.5902 0.794202C13.0342 0.286478 12.2803 0.00086009 11.494 0ZM3.18953 1.08333H11.494C11.966 1.08333 12.4186 1.25454 12.7524 1.55928C13.0861 1.86403 13.2736 2.27736 13.2736 2.70833V10.2917C13.2725 10.533 13.2117 10.7709 13.0956 10.9877L7.66032 6.02442C7.3849 5.77285 7.0579 5.57329 6.69801 5.43714C6.33812 5.30099 5.95239 5.23091 5.56284 5.23091C5.17328 5.23091 4.78755 5.30099 4.42766 5.43714C4.06777 5.57329 3.74077 5.77285 3.46536 6.02442L1.40999 7.90075V2.70833C1.40999 2.27736 1.59748 1.86403 1.9312 1.55928C2.26493 1.25454 2.71756 1.08333 3.18953 1.08333ZM3.18953 11.9167C2.71756 11.9167 2.26493 11.7455 1.9312 11.4407C1.59748 11.136 1.40999 10.7226 1.40999 10.2917V9.43258L4.30352 6.79033C4.46878 6.63933 4.665 6.51954 4.88098 6.43781C5.09696 6.35608 5.32845 6.31401 5.56224 6.31401C5.79603 6.31401 6.02753 6.35608 6.24351 6.43781C6.45948 6.51954 6.65571 6.63933 6.82097 6.79033L12.2563 11.7542C12.0189 11.8602 11.7583 11.9157 11.494 11.9167H3.18953Z"
          fill={color}
        />
        <path
          d="M9.71455 5.68742C10.1252 5.68742 10.5266 5.57623 10.868 5.36791C11.2094 5.1596 11.4755 4.86351 11.6326 4.51709C11.7898 4.17067 11.8309 3.78948 11.7508 3.42173C11.6707 3.05397 11.4729 2.71617 11.1826 2.45103C10.8922 2.18589 10.5223 2.00533 10.1196 1.93218C9.71686 1.85903 9.29942 1.89657 8.92006 2.04006C8.54069 2.18356 8.21645 2.42655 7.98832 2.73832C7.76019 3.05009 7.63843 3.41663 7.63843 3.79159C7.63843 4.29439 7.85716 4.7766 8.24651 5.13214C8.63586 5.48768 9.16393 5.68742 9.71455 5.68742ZM9.71455 2.97909C9.89053 2.97909 10.0626 3.02674 10.2089 3.11602C10.3552 3.2053 10.4692 3.33219 10.5366 3.48066C10.6039 3.62912 10.6216 3.79249 10.5872 3.9501C10.5529 4.10771 10.4682 4.25248 10.3437 4.36611C10.2193 4.47974 10.0607 4.55712 9.88814 4.58847C9.71554 4.61982 9.53664 4.60373 9.37405 4.54224C9.21147 4.48074 9.07251 4.3766 8.97474 4.24299C8.87697 4.10937 8.82479 3.95228 8.82479 3.79159C8.82479 3.5761 8.91853 3.36944 9.08539 3.21706C9.25226 3.06469 9.47857 2.97909 9.71455 2.97909Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_59_83">
          <rect width="14.2363" height="13" fill="white" transform="translate(0.223633)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SendIcon: React.FC<iconProps> = ({ color = '#fff', width = '13', height = '12' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M2.25692 6.50246H12.1714L2.27092 11.8405C2.05192 11.946 1.82542 11.9965 1.60492 11.9965C1.25692 11.9965 0.923921 11.869 0.66142 11.6295C0.241421 11.2445 0.10392 10.677 0.30192 10.1465L0.32992 10.085L2.25692 6.50246ZM2.18742 0.143463C1.66092 -0.107537 1.04442 -0.0160371 0.616921 0.376963C0.197421 0.762963 0.0604205 1.33096 0.26042 1.86096L2.24992 5.50246H12.1704L2.22542 0.163463L2.18742 0.143463Z" />
    </svg>
  );
};

export const Home: React.FC<iconProps> = ({ color = '#6E7E92', width = '18', height = '18' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4412 17.9499H12.6079C11.9448 17.9499 11.309 17.6865 10.8401 17.2177C10.3713 16.7488 10.1079 16.1129 10.1079 15.4499V11.7249C10.1072 11.5654 10.0713 11.408 10.0027 11.2639C9.9341 11.1199 9.83456 10.9928 9.71117 10.8917C9.58777 10.7906 9.44357 10.718 9.28887 10.6791C9.13416 10.6402 8.97277 10.6359 8.81623 10.6666C8.55626 10.7231 8.32447 10.8693 8.16145 11.0796C7.99843 11.2898 7.91457 11.5507 7.92456 11.8166V15.4166C7.92456 16.0796 7.66117 16.7155 7.19233 17.1843C6.72348 17.6532 6.0876 17.9166 5.42456 17.9166H2.55789C1.89485 17.9166 1.25897 17.6532 0.790126 17.1843C0.321285 16.7155 0.0578927 16.0796 0.0578927 15.4166V8.44157C0.0509284 7.82813 0.176076 7.22037 0.424834 6.65959C0.673593 6.0988 1.04013 5.59813 1.49956 5.19157L6.29956 1.0249C7.0531 0.383792 8.01019 0.0317383 8.99956 0.0317383C9.98893 0.0317383 10.946 0.383792 11.6996 1.0249L16.4912 5.19157C16.9563 5.59405 17.3295 6.0918 17.5854 6.6511C17.8413 7.2104 17.974 7.81817 17.9746 8.43324V15.4166C17.979 15.7505 17.9166 16.0819 17.7909 16.3913C17.6651 16.7007 17.4787 16.9818 17.2425 17.2179C17.0064 17.454 16.7254 17.6405 16.416 17.7662C16.1066 17.8919 15.7751 17.9544 15.4412 17.9499ZM8.99956 9.40824C9.61475 9.40823 10.2049 9.65204 10.6406 10.0863C11.0764 10.5205 11.3224 11.1097 11.3246 11.7249V15.4166C11.3246 15.7569 11.4598 16.0834 11.7004 16.324C11.9411 16.5647 12.2675 16.6999 12.6079 16.6999H15.4412C15.6105 16.701 15.7782 16.6686 15.9349 16.6046C16.0916 16.5406 16.234 16.4463 16.3541 16.327C16.4741 16.2077 16.5694 16.0659 16.6344 15.9096C16.6994 15.7534 16.7329 15.5858 16.7329 15.4166V8.43324C16.7304 7.9958 16.6339 7.564 16.4499 7.16715C16.2658 6.7703 15.9986 6.41769 15.6662 6.13324L10.8746 1.96657C10.3495 1.51816 9.68169 1.2718 8.99123 1.2718C8.30076 1.2718 7.63294 1.51816 7.10789 1.96657L2.33289 6.14157C1.99994 6.42499 1.73276 6.77759 1.54999 7.17481C1.36721 7.57203 1.27322 8.00432 1.27456 8.44157V15.4166C1.27456 15.5858 1.30802 15.7534 1.37304 15.9096C1.43805 16.0659 1.53333 16.2077 1.65338 16.327C1.77343 16.4463 1.91589 16.5406 2.07256 16.6046C2.22922 16.6686 2.397 16.701 2.56623 16.6999H5.39956C5.73847 16.6977 6.06276 16.5615 6.30163 16.3211C6.5405 16.0807 6.67457 15.7555 6.67456 15.4166V11.8166C6.66813 11.2549 6.85892 10.7087 7.21372 10.2732C7.56851 9.83773 8.06483 9.54047 8.61623 9.43324C8.7433 9.41634 8.87137 9.40799 8.99956 9.40824Z" />
    </svg>
  );
};

export const GridIcon: React.FC<iconProps> = ({ color = '#fff', width = '16', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5.00033 3.33341C5.00033 3.66305 4.90258 3.98528 4.71944 4.25937C4.53631 4.53345 4.27601 4.74707 3.97147 4.87321C3.66692 4.99936 3.33181 5.03237 3.00851 4.96806C2.68521 4.90375 2.38824 4.74501 2.15515 4.51193C1.92206 4.27884 1.76333 3.98187 1.69902 3.65857C1.63471 3.33526 1.66771 3.00015 1.79386 2.69561C1.92001 2.39107 2.13363 2.13077 2.40771 1.94763C2.68179 1.7645 3.00402 1.66675 3.33366 1.66675C3.77569 1.66675 4.19961 1.84234 4.51217 2.1549C4.82473 2.46746 5.00033 2.89139 5.00033 3.33341ZM8.00033 1.66675C7.67069 1.66675 7.34846 1.7645 7.07438 1.94763C6.80029 2.13077 6.58667 2.39107 6.46053 2.69561C6.33438 3.00015 6.30138 3.33526 6.36568 3.65857C6.42999 3.98187 6.58873 4.27884 6.82182 4.51193C7.0549 4.74501 7.35187 4.90375 7.67518 4.96806C7.99848 5.03237 8.33359 4.99936 8.63813 4.87321C8.94268 4.74707 9.20297 4.53345 9.38611 4.25937C9.56925 3.98528 9.66699 3.66305 9.66699 3.33341C9.66699 2.89139 9.4914 2.46746 9.17884 2.1549C8.86628 1.84234 8.44235 1.66675 8.00033 1.66675ZM14.3337 3.33341C14.3337 3.66305 14.2359 3.98528 14.0528 4.25937C13.8696 4.53345 13.6093 4.74707 13.3048 4.87321C13.0003 4.99936 12.6651 5.03237 12.3418 4.96806C12.0185 4.90375 11.7216 4.74501 11.4885 4.51193C11.2554 4.27884 11.0967 3.98187 11.0324 3.65857C10.968 3.33526 11.001 3.00015 11.1272 2.69561C11.2533 2.39107 11.467 2.13077 11.741 1.94763C12.0151 1.7645 12.3374 1.66675 12.667 1.66675C13.109 1.66675 13.5329 1.84234 13.8455 2.1549C14.1581 2.46746 14.3337 2.89139 14.3337 3.33341ZM5.00033 8.00008C5.00033 8.32972 4.90258 8.65195 4.71944 8.92603C4.53631 9.20011 4.27601 9.41374 3.97147 9.53988C3.66692 9.66603 3.33181 9.69903 3.00851 9.63472C2.68521 9.57042 2.38824 9.41168 2.15515 9.17859C1.92206 8.94551 1.76333 8.64853 1.69902 8.32523C1.63471 8.00193 1.66771 7.66682 1.79386 7.36228C1.92001 7.05773 2.13363 6.79743 2.40771 6.6143C2.68179 6.43116 3.00402 6.33342 3.33366 6.33342C3.77569 6.33342 4.19961 6.50901 4.51217 6.82157C4.82473 7.13413 5.00033 7.55805 5.00033 8.00008ZM9.66699 8.00008C9.66699 8.32972 9.56925 8.65195 9.38611 8.92603C9.20297 9.20011 8.94268 9.41374 8.63813 9.53988C8.33359 9.66603 7.99848 9.69903 7.67518 9.63472C7.35187 9.57042 7.0549 9.41168 6.82182 9.17859C6.58873 8.94551 6.42999 8.64853 6.36568 8.32523C6.30138 8.00193 6.33438 7.66682 6.46053 7.36228C6.58667 7.05773 6.80029 6.79743 7.07438 6.6143C7.34846 6.43116 7.67069 6.33342 8.00033 6.33342C8.44235 6.33342 8.86628 6.50901 9.17884 6.82157C9.4914 7.13413 9.66699 7.55805 9.66699 8.00008ZM14.3337 8.00008C14.3337 8.32972 14.2359 8.65195 14.0528 8.92603C13.8696 9.20011 13.6093 9.41374 13.3048 9.53988C13.0003 9.66603 12.6651 9.69903 12.3418 9.63472C12.0185 9.57042 11.7216 9.41168 11.4885 9.17859C11.2554 8.94551 11.0967 8.64853 11.0324 8.32523C10.968 8.00193 11.001 7.66682 11.1272 7.36228C11.2533 7.05773 11.467 6.79743 11.741 6.6143C12.0151 6.43116 12.3374 6.33342 12.667 6.33342C13.109 6.33342 13.5329 6.50901 13.8455 6.82157C14.1581 7.13413 14.3337 7.55805 14.3337 8.00008ZM5.00033 12.6667C5.00033 12.9964 4.90258 13.3186 4.71944 13.5927C4.53631 13.8668 4.27601 14.0804 3.97147 14.2065C3.66692 14.3327 3.33181 14.3657 3.00851 14.3014C2.68521 14.2371 2.38824 14.0783 2.15515 13.8453C1.92206 13.6122 1.76333 13.3152 1.69902 12.9919C1.63471 12.6686 1.66771 12.3335 1.79386 12.0289C1.92001 11.7244 2.13363 11.4641 2.40771 11.281C2.68179 11.0978 3.00402 11.0001 3.33366 11.0001C3.77569 11.0001 4.19961 11.1757 4.51217 11.4882C4.82473 11.8008 5.00033 12.2247 5.00033 12.6667ZM9.66699 12.6667C9.66699 12.9964 9.56925 13.3186 9.38611 13.5927C9.20297 13.8668 8.94268 14.0804 8.63813 14.2065C8.33359 14.3327 7.99848 14.3657 7.67518 14.3014C7.35187 14.2371 7.0549 14.0783 6.82182 13.8453C6.58873 13.6122 6.42999 13.3152 6.36568 12.9919C6.30138 12.6686 6.33438 12.3335 6.46053 12.0289C6.58667 11.7244 6.80029 11.4641 7.07438 11.281C7.34846 11.0978 7.67069 11.0001 8.00033 11.0001C8.44235 11.0001 8.86628 11.1757 9.17884 11.4882C9.4914 11.8008 9.66699 12.2247 9.66699 12.6667ZM14.3337 12.6667C14.3337 12.9964 14.2359 13.3186 14.0528 13.5927C13.8696 13.8668 13.6093 14.0804 13.3048 14.2065C13.0003 14.3327 12.6651 14.3657 12.3418 14.3014C12.0185 14.2371 11.7216 14.0783 11.4885 13.8453C11.2554 13.6122 11.0967 13.3152 11.0324 12.9919C10.968 12.6686 11.001 12.3335 11.1272 12.0289C11.2533 11.7244 11.467 11.4641 11.741 11.281C12.0151 11.0978 12.3374 11.0001 12.667 11.0001C13.109 11.0001 13.5329 11.1757 13.8455 11.4882C14.1581 11.8008 14.3337 12.2247 14.3337 12.6667Z" />
    </svg>
  );
};

export const ProfileEditIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '24',
  height = '24'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" />
    </svg>
  );
};

export const LogOutIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '24',
  height = '24'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7001 21.8021H7.26007C5.99024 21.8383 4.75724 21.3905 3.83126 20.557C2.90528 19.7235 2.36185 18.5722 2.32007 17.3554V5.6446C2.36185 4.4278 2.90528 3.2765 3.83126 2.44299C4.75724 1.60949 5.99024 1.16176 7.26007 1.19793H11.7001C12.9709 1.16173 14.205 1.60915 15.1325 2.4424C16.0601 3.27565 16.6057 4.42695 16.6501 5.6446C16.6501 5.83866 16.5703 6.02491 16.4281 6.16302C16.2858 6.30114 16.0925 6.37999 15.8901 6.38251C15.6867 6.38003 15.4923 6.30149 15.3485 6.16364C15.2046 6.02579 15.1227 5.83953 15.1201 5.6446C15.0786 4.81406 14.6954 4.03311 14.0544 3.47272C13.4134 2.91233 12.5669 2.61816 11.7001 2.6546H7.26007C6.39395 2.6207 5.54887 2.91575 4.90848 3.47562C4.26809 4.03549 3.88414 4.81495 3.84007 5.6446V17.3554C3.88414 18.1851 4.26809 18.9645 4.90848 19.5244C5.54887 20.0843 6.39395 20.3793 7.26007 20.3454H11.7001C12.5669 20.3819 13.4134 20.0877 14.0544 19.5273C14.6954 18.9669 15.0786 18.186 15.1201 17.3554C15.1227 17.1605 15.2046 16.9742 15.3485 16.8364C15.4923 16.6985 15.6867 16.62 15.8901 16.6175C16.0925 16.62 16.2858 16.6989 16.4281 16.837C16.5703 16.9751 16.6501 17.1614 16.6501 17.3554C16.6057 18.5731 16.0601 19.7244 15.1325 20.5576C14.205 21.3909 12.9709 21.8383 11.7001 21.8021ZM20.9201 10.7717H10.8601L12.5301 9.17126C12.6694 9.03207 12.7472 8.84665 12.7472 8.65376C12.7472 8.46087 12.6694 8.27545 12.5301 8.13626C12.4594 8.06788 12.3753 8.0136 12.2826 7.97656C12.1899 7.93951 12.0905 7.92044 11.9901 7.92044C11.8896 7.92044 11.7902 7.93951 11.6975 7.97656C11.6048 8.0136 11.5207 8.06788 11.4501 8.13626L8.45007 11.0113C8.37871 11.079 8.32207 11.1596 8.28342 11.2484C8.24476 11.3372 8.22486 11.4325 8.22486 11.5288C8.22486 11.625 8.24476 11.7203 8.28342 11.8091C8.32207 11.8979 8.37871 11.9785 8.45007 12.0463L11.4501 14.9213C11.5208 14.9892 11.6051 15.0428 11.6978 15.079C11.7906 15.1152 11.8899 15.1333 11.9901 15.1321C12.0901 15.1328 12.1893 15.1145 12.282 15.0783C12.3747 15.0421 12.459 14.9887 12.5301 14.9213C12.6694 14.7821 12.7472 14.5967 12.7472 14.4038C12.7472 14.2109 12.6694 14.0255 12.5301 13.8863L10.8601 12.2858H20.9201C21.0199 12.2858 21.1187 12.267 21.2109 12.2304C21.3031 12.1938 21.3869 12.1402 21.4575 12.0725C21.528 12.0049 21.584 11.9246 21.6222 11.8362C21.6604 11.7479 21.6801 11.6532 21.6801 11.5575C21.6801 11.4619 21.6604 11.3672 21.6222 11.2788C21.584 11.1904 21.528 11.1101 21.4575 11.0425C21.3869 10.9749 21.3031 10.9212 21.2109 10.8846C21.1187 10.848 21.0199 10.8292 20.9201 10.8292V10.7717Z" />
    </svg>
  );
};

export const EditIcon: React.FC<iconProps> = ({ color = '#000', width = '11', height = '11' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={color}>
      <g id="_01_align_center" data-name="01 align center">
        <path d="M22.94,1.06a3.626,3.626,0,0,0-5.124,0L0,18.876V24H5.124L22.94,6.184A3.627,3.627,0,0,0,22.94,1.06ZM4.3,22H2V19.7L15.31,6.4l2.3,2.3ZM21.526,4.77,19.019,7.277l-2.295-2.3L19.23,2.474a1.624,1.624,0,0,1,2.3,2.3Z" />
      </g>
    </svg>
  );
};

export const ThreeDots: React.FC<iconProps> = ({
  color = '#000000',
  width = '17',
  height = '17'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z"></path>
    </svg>
  );
};

export const DeleteIcon: React.FC<iconProps> = ({
  color = '#000',
  width = '11',
  height = '11'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path>
    </svg>
  );
};

export const LayoutIcon: React.FC<iconProps> = ({
  color = '#000',
  width = '25',
  height = '25'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z"></path>
    </svg>
  );
};

export const CardView = ({ isCardView }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill={isCardView ? '#037bfc' : '#000000'}
      viewBox="0 0 256 256">
      <path d="M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-96,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48v48Z"></path>
    </svg>
  );
};

export const ListView = ({ isCardView }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill={!isCardView ? '#037bfc' : '#000000'}
      viewBox="0 0 256 256">
      <path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path>
    </svg>
  );
};

export const LeftArrowIcon: React.FC<iconProps> = ({
  color = '#909090',
  width = '20',
  hanging = '20'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      hanging={hanging}
      fill={color}>
      <g id="arrows">
        <path
          id="black-left-line"
          d="M20.78,12a.76.76,0,0,1-.75.75H11.87V16a.57.57,0,0,1-1,.41l-4-4a.57.57,0,0,1,0-.8l4-4a.57.57,0,0,1,1,.39v3.23H20A.76.76,0,0,1,20.78,12Zm-17-7.16a.75.75,0,0,0-.75.75V18.41a.75.75,0,0,0,1.5,0V5.59A.74.74,0,0,0,3.83,4.84Z"
        />
      </g>
    </svg>
  );
};

export const RightArrowIcon: React.FC<iconProps> = ({
  color = '#909090',
  width = '20',
  hanging = '20'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      hanging={hanging}
      fill={color}>
      <g id="arrows">
        <path
          id="black-right-line"
          d="M16.92,11.91a.57.57,0,0,1,0,.8l-4,4a.57.57,0,0,1-1-.4V13.05H3.83a.75.75,0,0,1,0-1.5H12V8.33a.57.57,0,0,1,1-.4ZM20,4.82a.74.74,0,0,0-.75.75V18.4a.75.75,0,0,0,1.5,0V5.57A.75.75,0,0,0,20,4.82Z"
        />
      </g>
    </svg>
  );
};

export const PlusSquaredIcon: React.FC<iconProps> = ({
  color = '#3377FF',
  width = '18',
  height = '18'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12.2665 1.20834C12.8607 1.20834 13.4491 1.32538 13.9981 1.55278C14.5471 1.78019 15.046 2.11349 15.4662 2.53368C15.8863 2.95387 16.2197 3.4527 16.4471 4.0017C16.6745 4.55069 16.7915 5.13911 16.7915 5.73334V12.2667C16.7915 12.8609 16.6745 13.4493 16.4471 13.9983C16.2197 14.5473 15.8863 15.0461 15.4662 15.4663C15.046 15.8865 14.5471 16.2198 13.9981 16.4472C13.4491 16.6746 12.8607 16.7917 12.2665 16.7917H5.73317C4.53307 16.7917 3.38211 16.3149 2.53351 15.4663C1.68491 14.6177 1.20817 13.4668 1.20817 12.2667V5.73334C1.20817 4.53323 1.68491 3.38228 2.53351 2.53368C3.38211 1.68508 4.53307 1.20834 5.73317 1.20834H12.2665ZM5.10817 9.775H8.22484V12.8917C8.22484 13.0972 8.30649 13.2943 8.45183 13.4397C8.59717 13.585 8.79429 13.6667 8.99984 13.6667C9.20538 13.6667 9.4025 13.585 9.54784 13.4397C9.69318 13.2943 9.77484 13.0972 9.77484 12.8917V9.775H12.8915C13.097 9.775 13.2942 9.69335 13.4395 9.54801C13.5849 9.40267 13.6665 9.20555 13.6665 9C13.6665 8.79446 13.5849 8.59734 13.4395 8.452C13.2942 8.30666 13.097 8.225 12.8915 8.225H9.77484V5.10834C9.77484 4.90279 9.69318 4.70567 9.54784 4.56033C9.4025 4.41499 9.20538 4.33334 8.99984 4.33334C8.79429 4.33334 8.59717 4.41499 8.45183 4.56033C8.30649 4.70567 8.22484 4.90279 8.22484 5.10834V8.225H5.10817C4.90263 8.225 4.7055 8.30666 4.56016 8.452C4.41482 8.59734 4.33317 8.79446 4.33317 9C4.33317 9.20555 4.41482 9.40267 4.56016 9.54801C4.7055 9.69335 4.90263 9.775 5.10817 9.775ZM12.2665 0.0416718H5.73317C4.22365 0.0416718 2.77595 0.641328 1.70855 1.70872C0.64116 2.77612 0.0415039 4.22381 0.0415039 5.73334V12.2667C0.0415039 13.7762 0.64116 15.2239 1.70855 16.2913C2.77595 17.3587 4.22365 17.9583 5.73317 17.9583H12.2665C13.776 17.9583 15.2237 17.3587 16.2911 16.2913C17.3585 15.2239 17.9582 13.7762 17.9582 12.2667V5.73334C17.9582 4.22381 17.3585 2.77612 16.2911 1.70872C15.2237 0.641328 13.776 0.0416718 12.2665 0.0416718Z" />
    </svg>
  );
};

export const MinusSquaredIcon: React.FC<iconProps> = ({
  color = '#3377FF',
  width = '18',
  height = '18'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12.2665 1.20834C12.8607 1.20834 13.4491 1.32538 13.9981 1.55278C14.5471 1.78019 15.046 2.11349 15.4662 2.53368C15.8863 2.95387 16.2197 3.4527 16.4471 4.0017C16.6745 4.55069 16.7915 5.13911 16.7915 5.73334V12.2667C16.7915 12.8609 16.6745 13.4493 16.4471 13.9983C16.2197 14.5473 15.8863 15.0461 15.4662 15.4663C15.046 15.8865 14.5471 16.2198 13.9981 16.4472C13.4491 16.6746 12.8607 16.7917 12.2665 16.7917H5.73317C4.53307 16.7917 3.38211 16.3149 2.53351 15.4663C1.68491 14.6177 1.20817 13.4668 1.20817 12.2667V5.73334C1.20817 4.53323 1.68491 3.38228 2.53351 2.53368C3.38211 1.68508 4.53307 1.20834 5.73317 1.20834H12.2665ZM5.10817 9.775H12.8915C13.097 9.775 13.2942 9.69335 13.4395 9.54801C13.5849 9.40267 13.6665 9.20555 13.6665 9C13.6665 8.79446 13.5849 8.59734 13.4395 8.452C13.2942 8.30666 13.097 8.225 12.8915 8.225H5.10817C4.90263 8.225 4.7055 8.30666 4.56016 8.452C4.41482 8.59734 4.33317 8.79446 4.33317 9C4.33317 9.20555 4.41482 9.40267 4.56016 9.54801C4.7055 9.69335 4.90263 9.775 5.10817 9.775ZM12.2665 0.0416718H5.73317C4.22365 0.0416718 2.77595 0.641328 1.70855 1.70872C0.64116 2.77612 0.0415039 4.22381 0.0415039 5.73334V12.2667C0.0415039 13.7762 0.64116 15.2239 1.70855 16.2913C2.77595 17.3587 4.22365 17.9583 5.73317 17.9583H12.2665C13.776 17.9583 15.2237 17.3587 16.2911 16.2913C17.3585 15.2239 17.9582 13.7762 17.9582 12.2667V5.73334C17.9582 4.22381 17.3585 2.77612 16.2911 1.70872C15.2237 0.641328 13.776 0.0416718 12.2665 0.0416718Z" />
    </svg>
  );
};

export const LeftDownIcon: React.FC<iconProps> = ({
  color = '#3377FF',
  width = '6',
  height = '8'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0.330012 4.96486C0.329473 4.87159 0.347349 4.77913 0.382616 4.69279C0.417883 4.60645 0.469847 4.52791 0.535528 4.46169L4.7876 0.209626C4.85348 0.143202 4.93186 0.0904811 5.01822 0.0545024C5.10458 0.0185238 5.19721 0 5.29076 0C5.38431 0 5.47694 0.0185238 5.5633 0.0545024C5.64966 0.0904811 5.72804 0.143202 5.79392 0.209626C5.92591 0.342405 6 0.522022 6 0.709244C6 0.896467 5.92591 1.07608 5.79392 1.20886L2.03793 4.96486L5.79392 8.71376C5.92591 8.84654 6 9.02616 6 9.21338C6 9.4006 5.92591 9.58022 5.79392 9.713C5.72804 9.77942 5.64966 9.83214 5.5633 9.86812C5.47694 9.9041 5.38431 9.92263 5.29076 9.92263C5.19721 9.92263 5.10458 9.9041 5.01822 9.86812C4.93186 9.83214 4.85348 9.77942 4.7876 9.713L0.535528 5.46093C0.404604 5.32893 0.330795 5.15077 0.330012 4.96486Z" />
    </svg>
  );
};

export const RightDownIcon: React.FC<iconProps> = ({
  color = '#3377FF',
  width = '6',
  height = '10'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.66999 5.03514C5.67053 5.12841 5.65265 5.22087 5.61738 5.30721C5.58212 5.39355 5.53015 5.47209 5.46447 5.53831L1.2124 9.79037C1.14652 9.8568 1.06814 9.90952 0.981781 9.9455C0.895422 9.98148 0.802794 10 0.70924 10C0.615686 10 0.523058 9.98148 0.436699 9.9455C0.35034 9.90952 0.271959 9.8568 0.206078 9.79037C0.0740863 9.65759 0 9.47798 0 9.29076C0 9.10353 0.0740863 8.92392 0.206078 8.79114L3.96207 5.03514L0.206078 1.28624C0.0740863 1.15346 0 0.973841 0 0.786618C0 0.599396 0.0740863 0.41978 0.206078 0.287C0.271959 0.220576 0.35034 0.167855 0.436699 0.131877C0.523058 0.0958977 0.615686 0.0773745 0.70924 0.0773745C0.802794 0.0773745 0.895422 0.0958977 0.981781 0.131877C1.06814 0.167855 1.14652 0.220576 1.2124 0.287L5.46447 4.53907C5.5954 4.67107 5.66921 4.84923 5.66999 5.03514Z"
        fill="#3377FF"
      />
    </svg>
  );
};

export const ArrowRightLeftIcon: React.FC<iconProps> = ({
  color = '#6E7E92',
  width = '18',
  height = '15'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 15"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M17.275 11.325C17.2751 11.4893 17.2104 11.647 17.0949 11.764C16.9795 11.881 16.8227 11.9478 16.6584 11.95L2.7167 12L4.05837 13.4333C4.17541 13.5505 4.24115 13.7094 4.24115 13.875C4.24115 14.0406 4.17541 14.1995 4.05837 14.3167C3.94329 14.4193 3.79583 14.4783 3.6417 14.4833C3.55049 14.4805 3.46094 14.4582 3.37903 14.4179C3.29712 14.3777 3.22473 14.3204 3.1667 14.25L0.858371 11.75C0.755881 11.6354 0.699219 11.4871 0.699219 11.3333C0.699219 11.1796 0.755881 11.0313 0.858371 10.9167L3.10837 8.66667C3.22801 8.55109 3.38786 8.48648 3.5542 8.48648C3.72055 8.48648 3.8804 8.55109 4.00004 8.66667C4.10427 8.78039 4.1621 8.92906 4.1621 9.08333C4.1621 9.2376 4.10427 9.38627 4.00004 9.5L2.80004 10.7167H16.65C16.813 10.7166 16.9694 10.7802 17.0862 10.8938C17.2029 11.0074 17.2707 11.1621 17.275 11.325ZM14.775 0.633333C14.6632 0.525387 14.5138 0.465061 14.3584 0.465061C14.2029 0.465061 14.0536 0.525387 13.9417 0.633333C13.8392 0.747921 13.7826 0.896264 13.7826 1.05C13.7826 1.20374 13.8392 1.35208 13.9417 1.46667L15.175 2.71667H1.27504C1.12278 2.73434 0.982316 2.80735 0.880366 2.92181C0.778416 3.03628 0.722086 3.18422 0.722086 3.3375C0.722086 3.49078 0.778416 3.63872 0.880366 3.75319C0.982316 3.86765 1.12278 3.94066 1.27504 3.95833H15.2417L14 5.25833C13.9372 5.3161 13.8869 5.38629 13.8526 5.46447C13.8183 5.54265 13.8005 5.62711 13.8005 5.7125C13.8005 5.79789 13.8183 5.88235 13.8526 5.96053C13.8869 6.03871 13.9372 6.1089 14 6.16667C14.0552 6.22675 14.1221 6.27479 14.1967 6.30777C14.2713 6.34075 14.3518 6.35797 14.4334 6.35833C14.5867 6.34961 14.7305 6.28073 14.8334 6.16667L17.0667 3.925C17.184 3.8079 17.2499 3.64904 17.25 3.48333C17.2477 3.31718 17.1855 3.15744 17.075 3.03333L14.775 0.633333Z" />
    </svg>
  );
};

export const ChatIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '18',
  height = '15'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M14.7337 20.25H1.87791C1.44766 20.2452 1.0364 20.0721 0.732148 19.7679C0.427898 19.4636 0.254835 19.0523 0.25 18.6221V5.76628C0.25246 4.30403 0.834427 2.90237 1.8684 1.8684C2.90237 0.834427 4.30403 0.25246 5.76628 0.25H14.7337C16.196 0.25246 17.5976 0.834427 18.6316 1.8684C19.6656 2.90237 20.2475 4.30403 20.25 5.76628V14.7337C20.2475 16.196 19.6656 17.5976 18.6316 18.6316C17.5976 19.6656 16.196 20.2475 14.7337 20.25ZM5.76628 1.64535C4.6741 1.64781 3.62735 2.08276 2.85506 2.85506C2.08276 3.62735 1.64781 4.6741 1.64535 5.76628V18.6221C1.64535 18.6887 1.67181 18.7526 1.71891 18.7997C1.76601 18.8468 1.8299 18.8733 1.89651 18.8733H14.7337C15.8259 18.8708 16.8727 18.4358 17.6449 17.6635C18.4172 16.8913 18.8522 15.8445 18.8547 14.7523V5.76628C18.8522 4.6741 18.4172 3.62735 17.6449 2.85506C16.8727 2.08276 15.8259 1.64781 14.7337 1.64535H5.76628ZM15.3756 7.92442C15.3732 7.74013 15.2989 7.56407 15.1686 7.43375C15.0383 7.30343 14.8622 7.22915 14.6779 7.22674H5.82209C5.63706 7.22674 5.4596 7.30025 5.32876 7.43109C5.19792 7.56193 5.12442 7.73938 5.12442 7.92442C5.12442 8.10945 5.19792 8.28691 5.32876 8.41775C5.4596 8.54859 5.63706 8.62209 5.82209 8.62209H14.6779C14.8622 8.61968 15.0383 8.54541 15.1686 8.41508C15.2989 8.28476 15.3732 8.1087 15.3756 7.92442ZM12.4267 12.5756C12.4243 12.3913 12.3501 12.2152 12.2197 12.0849C12.0894 11.9546 11.9134 11.8803 11.7291 11.8779H5.82209C5.63706 11.8779 5.4596 11.9514 5.32876 12.0823C5.19792 12.2131 5.12442 12.3905 5.12442 12.5756C5.12442 12.7606 5.19792 12.9381 5.32876 13.0689C5.4596 13.1998 5.63706 13.2733 5.82209 13.2733H11.7291C11.9134 13.2708 12.0894 13.1966 12.2197 13.0662C12.3501 12.9359 12.4243 12.7599 12.4267 12.5756Z" />
    </svg>
  );
};

export const AttachIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '13',
  height = '13'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M12.7538 6.89576L7.08113 11.9229C6.30303 12.6127 5.2478 13.0002 4.1476 13C3.04739 12.9998 1.99233 12.6121 1.2145 11.922C0.436674 11.2319 -0.000194398 10.2961 6.48929e-08 9.32041C0.000194528 8.3447 0.437436 7.40901 1.21554 6.7192L8.00123 0.717876C8.52 0.258056 9.22348 -0.000172373 9.95693 8.63276e-08C10.3201 8.54793e-05 10.6797 0.0636073 11.0152 0.186938C11.3507 0.31027 11.6555 0.490995 11.9122 0.718796C12.1689 0.946597 12.3726 1.21701 12.5114 1.5146C12.6503 1.81219 12.7218 2.13113 12.7217 2.4532C12.7216 2.77528 12.6499 3.09418 12.5109 3.3917C12.3718 3.68923 12.168 3.95955 11.9112 4.18723L11.8994 4.19704L5.27686 9.85075C5.19833 9.91774 5.1057 9.97035 5.00425 10.0056C4.9028 10.0408 4.79451 10.058 4.68558 10.0561C4.57664 10.0542 4.46919 10.0333 4.36936 9.99463C4.26953 9.95593 4.17927 9.90016 4.10374 9.83052C4.02821 9.76088 3.96889 9.67873 3.92916 9.58876C3.88943 9.49878 3.87007 9.40275 3.87219 9.30614C3.87431 9.20954 3.89786 9.11424 3.94151 9.02571C3.98515 8.93717 4.04803 8.85713 4.12656 8.79014L10.7429 3.14256C10.9497 2.95801 11.0654 2.70817 11.0645 2.44799C11.0636 2.1878 10.9461 1.9386 10.738 1.75519C10.635 1.66437 10.5128 1.59245 10.3784 1.54351C10.244 1.49458 10.1001 1.4696 9.95485 1.47C9.66147 1.4708 9.38047 1.57493 9.17366 1.75948L2.38796 7.75897C1.92127 8.17302 1.65915 8.73452 1.65928 9.31996C1.65935 9.60984 1.72379 9.89687 1.84894 10.1647C1.97408 10.4325 2.15748 10.6758 2.38865 10.8807C2.61983 11.0856 2.89426 11.2482 3.19627 11.3591C3.49828 11.47 3.82195 11.527 4.14882 11.5269C4.80896 11.5268 5.442 11.2941 5.9087 10.8801L11.5814 5.85294C11.6586 5.7845 11.7502 5.73022 11.851 5.69318C11.9518 5.65615 12.0599 5.63709 12.169 5.63709C12.2781 5.63709 12.3862 5.65615 12.487 5.69318C12.5878 5.73022 12.6794 5.7845 12.7566 5.85294C12.8338 5.92137 12.895 6.00261 12.9367 6.09202C12.9785 6.18143 13 6.27727 13 6.37404C13 6.47082 12.9785 6.56665 12.9367 6.65607C12.895 6.74548 12.8338 6.82672 12.7566 6.89515L12.7538 6.89576Z" />
    </svg>
  );
};

export const EmojiIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '16',
  height = '16'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.49995 16.7744C3.94448 16.7744 0.239014 13.0557 0.239014 8.5002C0.239014 3.94473 3.94448 0.239258 8.49995 0.239258C13.0554 0.239258 16.7742 3.94473 16.7742 8.51348C16.7742 13.0822 13.0554 16.7744 8.49995 16.7744ZM8.49995 1.1291C4.43589 1.1291 1.12886 4.43613 1.12886 8.5002C1.12886 12.5643 4.43589 15.8713 8.49995 15.8713C12.564 15.8713 15.871 12.5643 15.871 8.5002C15.871 4.43613 12.564 1.1291 8.49995 1.1291ZM4.1438 6.0959C4.1438 6.69355 4.63521 7.18496 5.23286 7.18496C5.83052 7.18496 6.32192 6.69355 6.32192 6.0959C6.32192 5.49824 5.83052 5.00684 5.23286 5.00684C4.63521 5.00684 4.1438 5.49824 4.1438 6.0959ZM8.50005 13.1217C12.0594 13.1217 12.8032 9.89434 12.8032 9.89434H4.19692C4.19692 9.89434 4.94067 13.1217 8.50005 13.1217ZM11.7672 7.18496C11.1695 7.18496 10.6781 6.69355 10.6781 6.0959C10.6781 5.49824 11.1695 5.00684 11.7672 5.00684C12.3648 5.00684 12.8562 5.49824 12.8562 6.0959C12.8562 6.69355 12.3648 7.18496 11.7672 7.18496Z"
      />
    </svg>
  );
};

export const MicroPhoneIcon: React.FC<iconProps> = ({
  color = '#010929',
  width = '17',
  height = '17'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7751 12.8311V12.8278C12.8964 12.8278 14.6195 11.1014 14.6195 8.98348C14.6195 8.7225 14.4087 8.51172 14.1477 8.51172C13.8867 8.51172 13.6759 8.7225 13.6759 8.98348C13.6759 10.5828 12.3744 11.8843 10.7751 11.8843H6.22485C4.62555 11.8843 3.32404 10.5828 3.32404 8.98348C3.32404 8.7225 3.11325 8.51172 2.85228 8.51172C2.59131 8.51172 2.38052 8.7225 2.38052 8.98348C2.38052 11.1047 4.10696 12.8278 6.22485 12.8278H8.02823V14.1661H6.80032C5.49881 14.1661 4.43819 15.2267 4.43819 16.5282C4.43819 16.7892 4.64897 17 4.90995 17C4.90995 17 12.0867 17 12.09 17C12.5852 17 12.5584 16.4781 12.5551 16.4546C12.5149 15.1866 11.4711 14.1695 10.1963 14.1695H8.9684V12.8311H10.7751ZM10.1997 15.1096C10.8153 15.1096 11.3406 15.5044 11.5346 16.0531H5.46535C5.65941 15.5044 6.1847 15.1096 6.80032 15.1096H10.1997Z" />
      <path
        d="M10.7752 0H6.22487C5.14418 0 4.26758 0.876599 4.26758 1.95729V8.98012C4.26758 10.0608 5.14752 10.9374 6.22487 10.9374H10.7752C11.8558 10.9374 12.7324 10.0608 12.7324 8.98012V1.95729C12.7324 0.876599 11.8525 0 10.7752 0ZM11.7889 2.96772H10.5911C10.3302 2.96772 10.1194 3.17851 10.1194 3.43948C10.1194 3.70045 10.3302 3.91124 10.5911 3.91124H11.7889V4.99528H10.5911C10.3302 4.99528 10.1194 5.20606 10.1194 5.46703C10.1194 5.72801 10.3302 5.93879 10.5911 5.93879H11.7889V7.02617H10.5911C10.3302 7.02617 10.1194 7.23696 10.1194 7.49793C10.1194 7.7589 10.3302 7.96969 10.5911 7.96969H11.7889V8.98012C11.7889 9.53887 11.3339 9.9939 10.7752 9.9939H6.22487C5.66612 9.9939 5.21109 9.53887 5.21109 8.98012V7.96969H6.40889C6.66986 7.96969 6.88065 7.7589 6.88065 7.49793C6.88065 7.23696 6.66986 7.02617 6.40889 7.02617H5.21109V5.94214H6.40889C6.66986 5.94214 6.88065 5.73135 6.88065 5.47038C6.88065 5.20941 6.66986 4.99862 6.40889 4.99862H5.21109V3.91458H6.40889C6.66986 3.91458 6.88065 3.7038 6.88065 3.44283C6.88065 3.18185 6.66986 2.97107 6.40889 2.97107H5.21109V1.95729C5.21109 1.39854 5.66612 0.943515 6.22487 0.943515H10.7752C11.3339 0.943515 11.7889 1.39854 11.7889 1.95729V2.96772Z"
        fill="#010929"
      />
    </svg>
  );
};

export const SendMessageIcon = ({
  className
}: {
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <svg
      className={className}
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3871 5.51731L2.50273 0.142938C2.29433 0.0317017 2.05532 -0.0164407 1.8175 0.00491446C1.57968 0.0262696 1.35432 0.11611 1.17139 0.262487C0.988467 0.408863 0.856647 0.604837 0.793465 0.824342C0.730284 1.04385 0.738736 1.27648 0.817697 1.4913L2.59272 6.49916L0.817697 11.507C0.755292 11.676 0.736286 11.8567 0.762271 12.0341C0.788256 12.2115 0.858475 12.3803 0.967045 12.5265C1.07562 12.6727 1.21938 12.792 1.38628 12.8744C1.55319 12.9568 1.73838 12.9998 1.92635 13C2.12848 12.9996 2.32713 12.9498 2.50332 12.8554L2.50861 12.852L12.3894 7.46812C12.5706 7.3704 12.7213 7.22862 12.8262 7.05726C12.931 6.88589 12.9863 6.69108 12.9863 6.49272C12.9863 6.29435 12.931 6.09954 12.8262 5.92817C12.7213 5.75681 12.5706 5.61503 12.3894 5.51731H12.3871ZM2.34922 11.3893L3.84429 7.17166H7.10202C7.2892 7.17166 7.46872 7.10081 7.60107 6.97469C7.73343 6.84857 7.80779 6.67752 7.80779 6.49916C7.80779 6.3208 7.73343 6.14975 7.60107 6.02363C7.46872 5.89752 7.2892 5.82666 7.10202 5.82666H3.84429L2.34864 1.60786L11.3331 6.493L2.34922 11.3893Z"
        fill="white"
      />
    </svg>
  );
};

export const ChatDoubleTicks: React.FC<iconProps> = ({
  color = '#fff',
  width = '14px',
  height = '14px'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M8.33512 4.84312L3.43512 9.65562C3.3124 9.77619 3.14724 9.84375 2.9752 9.84375C2.80316 9.84375 2.638 9.77619 2.51528 9.65562L0.415277 7.59335C0.353766 7.53296 0.304754 7.46104 0.271038 7.3817C0.237323 7.30236 0.219565 7.21715 0.218777 7.13095C0.217188 6.95686 0.284822 6.78926 0.406801 6.66503C0.467198 6.60352 0.53912 6.55451 0.61846 6.5208C0.697799 6.48708 0.783003 6.46932 0.869205 6.46853C1.0433 6.46694 1.21089 6.53458 1.33512 6.65656L2.97575 8.26765L7.41582 3.90687C7.53998 3.78489 7.7075 3.71723 7.88155 3.71877C8.05559 3.72031 8.22189 3.79092 8.34387 3.91507C8.46585 4.03923 8.53351 4.20675 8.53197 4.3808C8.53044 4.55484 8.45982 4.72114 8.33567 4.84312H8.33512ZM13.5933 3.91343C13.5329 3.85171 13.4609 3.80253 13.3814 3.7687C13.3019 3.73487 13.2166 3.71707 13.1302 3.7163C13.0438 3.71554 12.9581 3.73184 12.8781 3.76426C12.798 3.79668 12.7251 3.84459 12.6636 3.90523L8.2252 8.26765L7.79426 7.84437C7.67011 7.72239 7.50258 7.65473 7.32854 7.65627C7.1545 7.65781 6.98819 7.72842 6.86621 7.85257C6.74424 7.97673 6.67657 8.14425 6.67811 8.3183C6.67965 8.49234 6.75026 8.65864 6.87442 8.78062L7.76528 9.65562C7.888 9.77619 8.05316 9.84375 8.2252 9.84375C8.39724 9.84375 8.5624 9.77619 8.68512 9.65562L13.5851 4.84312C13.6466 4.78272 13.6956 4.71081 13.7293 4.63148C13.7629 4.55216 13.7807 4.46697 13.7814 4.3808C13.7822 4.29462 13.766 4.20914 13.7337 4.12923C13.7014 4.04932 13.6537 3.97655 13.5933 3.91507V3.91343Z" />
    </svg>
  );
};

export const ChatFullScreenIcon: React.FC<iconProps> = ({
  color = '#000000',
  width = '12',
  height = '12'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M6.03279 14.2705H1.72951V9.96721C1.72951 9.62787 1.4541 9.35246 1.11475 9.35246C0.77541 9.35246 0.5 9.62787 0.5 9.96721V14.8852C0.5 15.2246 0.77541 15.5 1.11475 15.5H6.03279C6.37213 15.5 6.64754 15.2246 6.64754 14.8852C6.64754 14.5459 6.37213 14.2705 6.03279 14.2705ZM14.8852 9.35246C14.5459 9.35295 14.271 9.62787 14.2705 9.96721V14.2705H9.96721C9.62787 14.2705 9.35246 14.5459 9.35246 14.8852C9.35246 15.2246 9.62787 15.5 9.96721 15.5H14.8852C15.2246 15.4995 15.4995 15.2246 15.5 14.8852V9.96721C15.4995 9.62787 15.2246 9.35295 14.8852 9.35246ZM6.03279 0.5H1.11475C0.77541 0.5 0.5 0.77541 0.5 1.11475V6.03279C0.5 6.37213 0.77541 6.64754 1.11475 6.64754C1.4541 6.64754 1.72951 6.37213 1.72951 6.03279V1.72951H6.03279C6.37213 1.72951 6.64754 1.4541 6.64754 1.11475C6.64754 0.77541 6.37213 0.5 6.03279 0.5ZM14.8852 0.5H9.96721C9.62787 0.5 9.35246 0.77541 9.35246 1.11475C9.35246 1.4541 9.62787 1.72951 9.96721 1.72951H14.2705V6.03279C14.2705 6.37213 14.5459 6.64754 14.8852 6.64754C15.2246 6.64754 15.5 6.37213 15.5 6.03279V1.11475C15.5 0.77541 15.2246 0.5 14.8852 0.5Z" />
    </svg>
  );
};

export const InformationIcon: React.FC<iconProps> = ({
  color = '#777777',
  width = '12',
  height = '12'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill={color}
      style={{ display: 'inline-block', marginRight: '3px' }}
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M6.75 8.625H6.375V5.27325C6.375 5.26912 6.37387 5.26538 6.37387 5.26163C6.37387 5.25787 6.375 5.25413 6.375 5.25C6.375 5.043 6.207 4.875 6 4.875H5.25C5.043 4.875 4.875 5.043 4.875 5.25C4.875 5.457 5.043 5.625 5.25 5.625H5.625V8.625H5.25C5.043 8.625 4.875 8.793 4.875 9C4.875 9.207 5.043 9.375 5.25 9.375H6.75C6.957 9.375 7.125 9.207 7.125 9C7.125 8.793 6.957 8.625 6.75 8.625ZM6 4.125C6.41437 4.125 6.75 3.789 6.75 3.375C6.75 2.961 6.41437 2.625 6 2.625C5.58563 2.625 5.25 2.961 5.25 3.375C5.25 3.789 5.586 4.125 6 4.125ZM6 0C2.6865 0 0 2.68613 0 6C0 9.31388 2.68613 12 6 12C9.31388 12 12 9.31388 12 6C12 2.68613 9.31388 0 6 0ZM6 11.2616C3.105 11.2616 0.75 8.89462 0.75 5.99962C0.75 3.10462 3.105 0.749625 6 0.749625C8.895 0.749625 11.25 3.10462 11.25 5.99962C11.25 8.89462 8.895 11.2616 6 11.2616Z" />
      </g>
    </svg>
  );
};

export const EyeIcon: React.FC<iconProps> = ({
  color = '#3377FF',
  width = '15',
  height = '18'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 15"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9 10.2C8.46599 10.2 7.94397 10.0417 7.49996 9.74497C7.05595 9.44829 6.70988 9.02661 6.50552 8.53325C6.30117 8.03989 6.2477 7.49701 6.35188 6.97326C6.45606 6.44951 6.71321 5.96842 7.09081 5.59081C7.46841 5.21321 7.94951 4.95606 8.47325 4.85188C8.997 4.7477 9.53988 4.80117 10.0332 5.00553C10.5266 5.20988 10.9483 5.55595 11.245 5.99996C11.5416 6.44398 11.7 6.96599 11.7 7.5C11.698 8.21548 11.4129 8.90108 10.907 9.407C10.4011 9.91292 9.71547 10.198 9 10.2ZM9 5.925C8.68849 5.925 8.38398 6.01737 8.12498 6.19044C7.86597 6.3635 7.6641 6.60948 7.54489 6.89728C7.42568 7.18507 7.39449 7.50175 7.45526 7.80727C7.51603 8.11279 7.66604 8.39343 7.88631 8.6137C8.10657 8.83396 8.38721 8.98397 8.69273 9.04474C8.99825 9.10551 9.31493 9.07432 9.60273 8.95511C9.89052 8.83591 10.1365 8.63403 10.3096 8.37503C10.4826 8.11602 10.575 7.81151 10.575 7.5C10.575 7.08229 10.4091 6.68168 10.1137 6.38631C9.81832 6.09094 9.41771 5.925 9 5.925ZM9 14.4825C6.96761 14.3894 5.03474 13.5758 3.5475 12.1875C1.9125 10.755 0.9375 9 0.9375 7.5C0.9375 4.17 5.16 0.517502 9 0.517502C12.84 0.517502 17.0625 4.2675 17.0625 7.5C17.0625 10.89 12.915 14.4825 9 14.4825ZM9 1.6425C5.8275 1.6425 2.0625 4.815 2.0625 7.5C2.0625 8.67 2.9175 10.14 4.3125 11.34C5.59289 12.5371 7.25045 13.2505 9 13.3575C12.57 13.3575 15.9375 10.0575 15.9375 7.5C15.9375 5.0775 12.3525 1.6425 9 1.6425Z" />
    </svg>
  );
};

export const DropDownIcon: React.FC<iconProps> = ({
  color = '#000000',
  width = '16',
  height = '16'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
    </svg>
  );
};

export const AiIcon: React.FC<iconProps> = ({ color = '#010929', width = '20', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_129_74" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <path d="M20 0H0V20H20V0Z" fill="#fff" />
      </mask>
      <g mask="url(#mask0_129_74)">
        <path d="M13.5486 13.8281V8.86719C13.5486 8.32773 13.9856 7.89062 14.5248 7.89062C15.0639 7.89062 15.5009 8.32773 15.5009 8.86719V13.8281C15.5009 14.3676 15.0639 14.8047 14.5248 14.8047C13.9856 14.8047 13.5486 14.3676 13.5486 13.8281ZM9.33174 13.8672V11.9531H6.44242V13.8672C6.44242 14.4067 6.00551 14.8438 5.4663 14.8438C4.92709 14.8438 4.49017 14.4067 4.49017 13.8672V8.57422C4.49017 6.70039 6.0141 5.17578 7.88709 5.17578C9.76007 5.17578 11.284 6.70039 11.284 8.57422V13.8672C11.284 14.4067 10.8471 14.8438 10.3079 14.8438C9.76865 14.8438 9.33174 14.4067 9.33174 13.8672ZM9.33174 10V8.57422C9.33174 7.77734 8.6836 7.12891 7.88709 7.12891C7.09057 7.12891 6.44242 7.77734 6.44242 8.57422V10H9.33174ZM14.3474 3.66992L15.4782 4.16874C15.6368 4.23867 15.7632 4.36523 15.8331 4.52383L16.3318 5.65508C16.575 6.20742 17.3582 6.20742 17.6014 5.65508L18.1001 4.52383C18.17 4.36523 18.2964 4.23867 18.455 4.16874L19.5858 3.66992C20.1378 3.42657 20.1378 2.64297 19.5858 2.39961L18.455 1.90078C18.2964 1.83086 18.17 1.7043 18.1001 1.5457L17.6014 0.414453C17.3582 -0.137891 16.575 -0.137891 16.3318 0.414453L15.8331 1.5457C15.7632 1.7043 15.6368 1.83086 15.4782 1.90078L14.3474 2.39961C13.7953 2.64297 13.7953 3.42657 14.3474 3.66992ZM19.0149 7.92969C18.4757 7.92969 18.0388 8.3668 18.0388 8.90624V16.6797C18.0388 17.4336 17.4258 18.0469 16.6722 18.0469H3.31882C2.95337 18.0469 2.61016 17.9043 2.35207 17.6461C2.09398 17.3874 1.95186 17.0438 1.95224 16.6786L1.96552 3.31914C1.96631 2.56601 2.57931 1.95312 3.3321 1.95312H11.0107C11.5499 1.95312 11.9868 1.51601 11.9868 0.976562C11.9868 0.437109 11.5499 0 11.0107 0H3.3321C1.50401 0 0.0152291 1.48789 0.0132769 3.31719L1.32436e-06 16.6766C-0.000779787 17.5641 0.343988 18.3984 0.971045 19.0266C1.59811 19.6547 2.43172 20.0004 3.31882 20.0004H16.6722C18.5022 20.0004 19.991 18.5109 19.991 16.6801V8.90664C19.991 8.36719 19.5541 7.92969 19.0149 7.92969Z" />
      </g>
    </svg>
  );
};

export const AddMember: React.FC<iconProps> = ({
  color = '#000000',
  width = '24',
  height = '24'
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      height={height}
      width={width}
      preserveAspectRatio="xMidYMid meet"
      version="1.1"
      x="0px"
      y="0px"
      enableBackground="new 0 0 24 24">
      <title>add-user</title>
      <path
        fill={color}
        d="M14.7,12c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6S12.7,12,14.7,12z  M6.6,10.2V7.5H4.8v2.7H2.1V12h2.7v2.7h1.8V12h2.7v-1.8H6.6z M14.7,13.8c-2.4,0-7.2,1.2-7.2,3.6v1.8H22v-1.8 C21.9,15,17.1,13.8,14.7,13.8z"></path>
    </svg>
  );
};

export const ImportIcon: React.FC<iconProps> = ({
  color = '#000',
  height = '15',
  width = '15'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"></path>
    </svg>
  );
};
export const ExportIcon: React.FC<iconProps> = ({
  color = '#000',
  height = '15',
  width = '15'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96H80a8,8,0,0,1,0,16H56v96H200V112H176a8,8,0,0,1,0-16h24A16,16,0,0,1,216,112ZM93.66,69.66,120,43.31V136a8,8,0,0,0,16,0V43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66Z"></path>
    </svg>
  );
};

export const RestoreIcon: React.FC<iconProps> = ({
  color = '#000000',
  width = '24',
  height = '24'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V76.69L62.63,62.06A95.43,95.43,0,0,1,130,33.94h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.56,79.56,0,0,0,73.94,73.37L59.31,88H88a8,8,0,0,1,0,16Zm128,48H168a8,8,0,0,0,0,16h28.69l-14.63,14.63a79.56,79.56,0,0,1-56.13,23.43h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.43,95.43,0,0,0,67.36-28.12L208,179.31V208a8,8,0,0,0,16,0V160A8,8,0,0,0,216,152Z"></path>
    </svg>
  );
};

export const HomeIcon: React.FC<iconProps> = ({
  color = '#6E7E92',
  width = '17',
  height = '18'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9755 16.6075H11.5671C11.0036 16.6075 10.4631 16.3836 10.0645 15.9851C9.66603 15.5866 9.44215 15.0461 9.44215 14.4825V11.3162C9.44155 11.1807 9.41101 11.0469 9.35272 10.9244C9.29443 10.802 9.20982 10.694 9.10493 10.608C9.00004 10.5221 8.87747 10.4604 8.74598 10.4273C8.61448 10.3942 8.47729 10.3906 8.34423 10.4167C8.12326 10.4647 7.92624 10.589 7.78767 10.7677C7.6491 10.9464 7.57782 11.1682 7.58631 11.3942V14.4542C7.58631 15.0178 7.36243 15.5583 6.96392 15.9568C6.5654 16.3553 6.0249 16.5792 5.46131 16.5792H3.02465C2.46106 16.5792 1.92056 16.3553 1.52205 15.9568C1.12353 15.5583 0.899648 15.0178 0.899648 14.4542V8.52542C0.893729 8.00399 1.0001 7.4874 1.21155 7.01073C1.42299 6.53406 1.73455 6.10849 2.12506 5.76292L6.20506 2.22125C6.84558 1.67631 7.6591 1.37706 8.50006 1.37706C9.34103 1.37706 10.1546 1.67631 10.7951 2.22125L14.868 5.76292C15.2633 6.10503 15.5805 6.52812 15.798 7.00352C16.0156 7.47892 16.1284 7.99552 16.1288 8.51833V14.4542C16.1326 14.738 16.0795 15.0197 15.9727 15.2827C15.8658 15.5457 15.7073 15.7846 15.5066 15.9853C15.3059 16.186 15.067 16.3445 14.804 16.4513C14.541 16.5582 14.2593 16.6113 13.9755 16.6075ZM8.50006 9.34708C9.02297 9.34708 9.52457 9.55432 9.89499 9.92341C10.2654 10.2925 10.4744 10.7933 10.4763 11.3162V14.4542C10.4763 14.7435 10.5912 15.0209 10.7958 15.2255C11.0004 15.4301 11.2778 15.545 11.5671 15.545H13.9755C14.1193 15.5459 14.2619 15.5184 14.3951 15.464C14.5283 15.4096 14.6494 15.3294 14.7514 15.228C14.8534 15.1266 14.9344 15.0061 14.9897 14.8733C15.045 14.7404 15.0734 14.598 15.0734 14.4542V8.51833C15.0713 8.14651 14.9893 7.77948 14.8328 7.44216C14.6764 7.10484 14.4492 6.80512 14.1667 6.56333L10.0938 3.02167C9.64752 2.64052 9.07988 2.43112 8.49298 2.43112C7.90608 2.43112 7.33844 2.64052 6.89215 3.02167L2.8334 6.57042C2.55038 6.81133 2.32329 7.11104 2.16793 7.44867C2.01257 7.78631 1.93267 8.15375 1.93381 8.52542V14.4542C1.93381 14.598 1.96226 14.7404 2.01752 14.8733C2.07278 15.0061 2.15377 15.1266 2.25581 15.228C2.35786 15.3294 2.47895 15.4096 2.61211 15.464C2.74528 15.5184 2.88789 15.5459 3.03173 15.545H5.44006C5.72814 15.5431 6.00378 15.4274 6.20682 15.223C6.40987 15.0186 6.52382 14.7423 6.52381 14.4542V11.3942C6.51835 10.9167 6.68052 10.4525 6.9821 10.0823C7.28368 9.71215 7.70554 9.45949 8.17423 9.36833C8.28224 9.35397 8.3911 9.34687 8.50006 9.34708Z"
        fill={color}
      />
    </svg>
  );
};

export const DataBaseIcon: React.FC<iconProps> = ({
  color = '#000',
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 256 256">
      <path d="M128,24C74.17,24,32,48.6,32,80v96c0,31.4,42.17,56,96,56s96-24.6,96-56V80C224,48.6,181.83,24,128,24Zm80,104c0,9.62-7.88,19.43-21.61,26.92C170.93,163.35,150.19,168,128,168s-42.93-4.65-58.39-13.08C55.88,147.43,48,137.62,48,128V111.36c17.06,15,46.23,24.64,80,24.64s62.94-9.68,80-24.64ZM69.61,53.08C85.07,44.65,105.81,40,128,40s42.93,4.65,58.39,13.08C200.12,60.57,208,70.38,208,80s-7.88,19.43-21.61,26.92C170.93,115.35,150.19,120,128,120s-42.93-4.65-58.39-13.08C55.88,99.43,48,89.62,48,80S55.88,60.57,69.61,53.08ZM186.39,202.92C170.93,211.35,150.19,216,128,216s-42.93-4.65-58.39-13.08C55.88,195.43,48,185.62,48,176V159.36c17.06,15,46.23,24.64,80,24.64s62.94-9.68,80-24.64V176C208,185.62,200.12,195.43,186.39,202.92Z"></path>
    </svg>
  );
};

export const BuildingIcon: React.FC<iconProps> = ({
  width = '20',
  height = '20'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill='black'
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.9375 2.5V16.25H11.8125V2.5H3.9375ZM3.28125 1.25H12.4688C12.6428 1.25 12.8097 1.31585 12.9328 1.43306C13.0559 1.55027 13.125 1.70924 13.125 1.875V16.875C13.125 17.0408 13.0559 17.1997 12.9328 17.3169C12.8097 17.4342 12.6428 17.5 12.4688 17.5H3.28125C3.1072 17.5 2.94028 17.4342 2.81721 17.3169C2.69414 17.1997 2.625 17.0408 2.625 16.875V1.875C2.625 1.70924 2.69414 1.55027 2.81721 1.43306C2.94028 1.31585 3.1072 1.25 3.28125 1.25Z"
      />
      <path
        d="M5.25 5H10.5V6.25H5.25V5ZM5.25 8.75H10.5V10H5.25V8.75ZM5.25 12.5H10.5V13.75H5.25V12.5ZM13.125 10H15.75V11.25H13.125V10ZM13.125 12.5H15.75V13.75H13.125V12.5ZM1.3125 16.25H19.6875V17.5H1.3125V16.25Z"
      />
      <path
        d="M13.125 7.5V16.25H17.0625V7.5H13.125ZM12.4688 6.25H17.7188C17.8928 6.25 18.0597 6.31585 18.1828 6.43306C18.3059 6.55027 18.375 6.70924 18.375 6.875V16.875C18.375 17.0408 18.3059 17.1997 18.1828 17.3169C18.0597 17.4342 17.8928 17.5 17.7188 17.5H12.4688C12.2947 17.5 12.1278 17.4342 12.0047 17.3169C11.8816 17.1997 11.8125 17.0408 11.8125 16.875V6.875C11.8125 6.70924 11.8816 6.55027 12.0047 6.43306C12.1278 6.31585 12.2947 6.25 12.4688 6.25Z"
      />
    </svg>
  );
};
